module.exports = __webpack_public_path__ + "media/categories/1043-68153880.svg";